/**
 * @readonly
 * @enum {strring}
 * 是否使用2.25新版商品信息 1:是，2:否
 */
export const USE_225_STYLE = {
  yes: 1,
  no: 2
}

// 商品视频的类型： 1是没有视频，2是普通视频 3: 实拍视频
export const GOOD_VIDEO_TYPE = {
  NONE: 1,
  NORMAL: 2,
  REAL_SHOT: 3
}

// im类型
export const IM_TYPE = {
  ONLINE_SERVICE: 1,
  EXCLUSIVE_SELLER: 2,
  POP_SERVICE: 3
}

export const COUPON_TYPE = {
  // 满减券
  REDUCE_COUPON: 1,
  // 代金券
  CASH_COUPON: 2,
  // 运费券
  FREIGHT_COUPON: 3,
  // 折扣券
  DISCOUNT_COUPON: 4,
  // 实物券
  MATERIAl_COUPON: 5,
  // 单品券
  SINGLE_RODUCT_COUPON: 6,
  // 运费劵
  NEW_FREIGHT_COUPON: 7,
  // 服务劵
  TIME_SERVICE_COUPON: 8
}
